<script setup>
import { getCurrentInstance, ref } from 'vue'
import { notifyDialog, notifyDialogError } from '../composables/useDialogNotice'

const props = defineProps({
    receiverId: {
        type: [String, Number],
        default: null,
    },
    isGift: {
        type: Boolean,
        default: false,
    },
})

const { proxy } = getCurrentInstance()
const loading = ref(false)

async function startCheckout() {
    if (loading.value) return

    loading.value = true
    try {
        const result = await proxy.$api({
            serviceName: 'stripeCheckout',
            methodName: 'createPremiumCheckout',
            parameters: [props.isGift ? props.receiverId : null],
        })

        if (result?.url) {
            window.location.assign(result.url)
            return
        }
        notifyDialog({ type: 'error', message: result?.error || 'Could not create the Stripe Checkout session.' })
    } catch (exception) {
        console.error('Stripe Checkout error:', exception)
        notifyDialogError(exception, 'Could not connect to the payment server.')
    } finally {
        loading.value = false
    }
}
</script>

<template><div class="stripe-checkout-container">
        <div class="checkout-ready">
            <v-btn block color="primary" variant="elevated" size="large" :loading="loading" :disabled="loading" class="checkout-button" @click="startCheckout">
                <img class="stripe-logo" src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/stripe.svg" alt="Stripe">
                {{ isGift ? 'Gift Premium' : 'Pay with Stripe' }}
                <v-icon end>mdi-arrow-right</v-icon>
            </v-btn>
            <div class="payment-logos mt-4">
                <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/visa.svg" alt="Visa" class="payment-logo">
                <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/mastercard.svg" alt="Mastercard" class="payment-logo">
                <img src="https://cdn.jsdelivr.net/gh/simple-icons/simple-icons/icons/americanexpress.svg" alt="American Express" class="payment-logo">
            </div>
            <p class="security-note mt-4">
                <v-icon size="16" color="success">mdi-shield-lock</v-icon>
                Secure payment processed by Stripe.
            </p>
        </div>
    </div></template>

<style scoped>
.stripe-checkout-container {
  padding:16px 0}
.checkout-button {
  font-weight:600;
  padding:12px 0;
  font-size:16px}
.checkout-button .stripe-logo {
  height:20px;
  width:auto;
  margin-right:8px;
  filter:brightness(0) invert(1);
  vertical-align:middle}
.payment-logos {
  display:flex;
  justify-content:center;
  gap:12px;
  flex-wrap:wrap}
.payment-logo {
  height:24px;
  width:auto;
  opacity:.9;
  filter:brightness(0) invert(1)}
.security-note {
  font-size:12px;
  color:var(--ink-soft);
  text-align:center;
  display:flex;
  align-items:center;
  justify-content:center;
  gap:8px}
.error-message {
  background-color:#f443361a;
  color:#f44336;
  padding:12px;
  border-radius:4px;
  margin-bottom:16px}
</style>
